// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateProject_wrapper__P-6Is","create-post":"CreateProject_create-post__Eyq2M","form-group":"CreateProject_form-group__0oigE"};